module.exports = __webpack_public_path__ + "static/media/facebook-2.fb2b3840.svg";